import { supabase } from '@/supabase/client'
import { logError } from '@/lib/sentry'

interface LogUsageParams {
  userId?: string | null
  pseudoUserId: string
  isMember: boolean
  type?: string
}

export async function logUsage({ userId, pseudoUserId, isMember, type = 'clipboard' }: LogUsageParams) {
  // 한국 시간으로 today 설정
  const now = new Date()
  const koreaTime = new Date(now.getTime() + (9 * 60 * 60 * 1000))
  const today = koreaTime.toISOString().split('T')[0]

  try {
    let query = supabase
      .from('usage_log')
      .select('usage_count')
      .eq('usage_date', today)
      .eq('type', type)

    // 회원/비회원 구분에 따른 쿼리 조건 설정
    if (isMember && userId) {
      query = query
        .eq('user_id', userId)
        .is('pseudo_user_id', null)
    } else {
      query = query
        .is('user_id', null)
        .eq('pseudo_user_id', pseudoUserId)
    }

    // 1. 먼저 오늘 날짜의 로그 확인
    const { data: existingLog } = await query.maybeSingle()

    if (existingLog) {
      // 2. 기존 로그가 있으면 usage_count 증가
      const { error } = await supabase
        .from('usage_log')
        .update({ usage_count: existingLog.usage_count + 1 })
        .eq('usage_date', today)
        .eq('type', type)
        .eq(isMember ? 'user_id' : 'pseudo_user_id', isMember ? userId : pseudoUserId)
        .is(isMember ? 'pseudo_user_id' : 'user_id', null)

      if (error) throw error
    } else {
      // 3. 기존 로그가 없으면 새로 생성
      const { error } = await supabase
        .from('usage_log')
        .insert({
          user_id: isMember ? userId : null,
          pseudo_user_id: isMember ? null : pseudoUserId,
          is_member: isMember,
          usage_date: today,
          type: type,
          usage_count: 1
        })

      if (error) throw error
    }
  } catch (error) {
    logError('Failed to log usage:', error)
  }
} 